<template>
  <div class="wrap">
    <div class="header">
      <div class="headline">商家免费入驻 <br />自助操作 灵活便捷</div>
      <div class="subtitle">高德地图旗下 车主服务平台</div>
    </div>

    <div class="center">
      <div class="outline">
        <div class="outline__info">
          <img class="outline__info__icon" src="static/img/amap_logo.png" />
          <div class="outline__info__text">
            <h3>德友惠 · MOBILE工作台</h3>
            <p>高德地图车主服务平台</p>
          </div>
        </div>
        <h1 class="outline__title">高德引流</h1>
        <p class="outline__content">
          德友惠无缝集成在高德地图的搜索、导航等功能模块中。
          依托于高德地图的庞大用户群，将目标用户引流到与高德签约的
          商家购买加油、洗车、维修保养等服务。
        </p>
      </div>

      <div class="action">
        <mt-button type="primary" @click="backToApp">返回应用</mt-button>
      </div>
    </div>

    <div class="footer">
      <div class="contact-dyh">
        联系我们：kefu@deyouhui.com.cn<br />
        深圳市德友惠信息技术有限公司<br />

        <a href="https://beian.miit.gov.cn" target="_blank"
          >粤ICP备20057452号-1</a
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';

import uni from '@/libs/uni_webview/uni.webview.1.5.4.js';
import StorageService from '@/services/storage.service';

@Component({})
export default class Index extends Vue {
  @lazyInject(StorageService)
  protected storage!: StorageService;

  private backToApp() {
    uni.navigateBack(1);
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-direction: column;

  height: 100vh;
  justify-content: space-between;
  .header {
    padding-top: 40px;
    .headline {
      color: #333;
      font-size: 28px;
      font-weight: 600;
      text-align: center;
    }
    .subtitle {
      font-size: 18;
      font-weight: 300;
      color: #999999;
      margin-top: 20px;
      text-align: center;
    }
  }
  .center {
    .outline {
      background: rgba(249, 249, 249, 1);
      border: 1px solid rgba(238, 238, 238, 1);
      border-radius: 10px;
      margin: 0 30px;
      padding: 15px 20px;
      &__info {
        align-items: center;
        background: rgba(66, 135, 255, 1);
        border-radius: 6px;
        display: flex;
        flex-direction: row;
        img {
          display: inline-block;
          height: 56px;
          margin: 28px 0 28px 15px;
          width: 45px;
        }
        &__text {
          color: #fff;
          flex: 1;
          text-align: center;
          h3 {
            font-size: 18px;
          }
        }
      }
      &__title {
        color: rgba(51, 51, 51, 1);
        font-size: 23px;
        font-weight: 600;
        padding: 30px 0 10px 0;
        text-align: center;
      }
      &__content {
        color: rgba(153, 153, 153, 1);
        font-size: 10px;
        font-weight: 300;
        line-height: 18px;
        margin-top: 0.45rem;
      }
    }
    .action {
      margin-top: 20px;
      text-align: center;
      button {
        margin: 0 auto;
      }
      .mint-button--primary {
        background: rgba(66, 135, 255, 1);
      }
    }
  }
  .footer {
    background: rgba(249, 249, 249, 1);
    padding: 10px 0;
    .contact-dyh {
      color: #999;
      font-size: 10px;
      font-weight: 300;
      text-align: center;
      a {
        font-size: 10px;
        font-weight: 300;
      }
    }
  }
}
</style>
